module.exports = __webpack_public_path__ + "static/img/57-1.8e23045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/57-1.jpg
// module id = eN1p
// module chunks = 0